import React from "react";
import { ActionButton, Block, Col, FormCheckbox, Row } from "../../../components/Component";
import { useState } from "react";
import { listHospitalAPI } from "../clients/hospital/HospitalTableData";
import { ServerStatusType } from "../../../utils";
import { useEffect } from "react";
import { Form, Spinner } from "reactstrap";
import { useContext } from "react";
import { CarerWizardContext } from "./AddCarer";
import { CarerPreviousButton } from "../../../components/button/ActionButton";

const CarerHomeCare = ({ onNext, onPrev, isValid }) => {
  const { data, updateData } = useContext(CarerWizardContext);
  const [hospitalList, setHospitalList] = useState([]);
  const [loadingDetail, setLoadingDetail] = useState(true);
  const [selectAll, setSelectAll] = useState(false);
  const [itHasChanges, setItHasChanges] = useState(false);
  const formattedBranch = hospitalList
    ?.map((item) => ({
      id: item?.branch?.id,
      value: item?.branch?.value,
      label: item?.branch?.label,
    }))
    .filter(
      (value, index, self) =>
        index ===
        self.findIndex(
          (t) => t.value === value.value && t.id !== undefined && t.value !== undefined && t.label !== undefined
        )
    );

  // Move hospitals that do not fit into any branch to "Other"
  const otherHomeCare = hospitalList.filter((hospital) => {
    return !formattedBranch.some((branch) => branch.id === hospital?.branch?.id);
  });

  useEffect(() => {
    loadHospital();
  }, []);

  useEffect(() => {
    setSelectAll(hospitalList.every((item) => data?.hospital?.includes(item.id)));
    isValid(false, itHasChanges);
  }, [hospitalList, data]);

  const handleSelectAllChange = (e) => {
    setItHasChanges(true);
    const isChecked = e.target.checked;
    setSelectAll(isChecked);
    const updatedHospitalList = isChecked ? hospitalList.map((item) => item.id) : [];
    updateData("hospital", updatedHospitalList);
  };

  const handleBranchChange = (branchItem, e) => {
    setItHasChanges(true);
    const isChecked = e.target.checked;
    let updatedList = [...data.hospital];

    hospitalList
      .filter((item) => item?.branch?.id === branchItem.id)
      .forEach((hospitalItem) => {
        if (isChecked) {
          if (!updatedList.includes(hospitalItem.id)) {
            updatedList.push(hospitalItem.id);
          }
        } else {
          updatedList = updatedList.filter((id) => id !== hospitalItem.id);
        }
      });
    updateData("hospital", updatedList);
  };

  const handleOtherChange = (e) => {
    setItHasChanges(true);
    const isChecked = e.target.checked;
    let updatedList = [...data.hospital];

    if (isChecked) {
      otherHomeCare.forEach((hospital) => {
        if (!updatedList.includes(hospital.id)) {
          updatedList.push(hospital.id);
        }
      });
    } else {
      updatedList = updatedList.filter((id) => !otherHomeCare.some((hospital) => hospital.id === id));
    }
    updateData("hospital", updatedList);
  };

  const handleOtherHospitalChange = (e, hospitalId) => {
    setItHasChanges(true);
    const isChecked = e.target.checked;
    let updatedList = [...data.hospital];

    if (isChecked) {
      updatedList.push(hospitalId);
    } else {
      updatedList = updatedList.filter((id) => id !== hospitalId);
    }

    updateData("hospital", updatedList);
  };

  function loadHospital() {
    setLoadingDetail(true);

    listHospitalAPI(
      {
        clientType: "CAREHOME",
        status: ServerStatusType.active,
      },
      (list, error) => {
        if (error === null) {
          setHospitalList(list?.list);
        }
        setLoadingDetail(false);
      }
    );
  }

  return (
    <div>
      <Form>
        {loadingDetail ? (
          <div className="spinner d-flex justify-content-center">
            <Spinner size="sm" color="primary" />
          </div>
        ) : (
          <Row>
            <FormCheckbox
              id={"select"}
              label={"Select All"}
              name={"Select All"}
              labelClassName="fw-bold"
              checked={selectAll}
              onChange={handleSelectAllChange}
            />
            <Col className="col-12">
              {formattedBranch?.map((branchItem, id) => {
                const allHospitalsChecked = hospitalList
                  ?.filter((item) => item?.branch?.id === branchItem?.id)
                  .every((hospital) => data?.hospital.includes(hospital.id));
                return (
                  <React.Fragment key={id}>
                    <Col className="col-12 col-sm-6">
                      <div className="form-group">
                        <FormCheckbox
                          label={branchItem?.label}
                          labelClassName="fw-bold"
                          id={"status" + id}
                          name="status"
                          checked={allHospitalsChecked}
                          onChange={(e) => handleBranchChange(branchItem, e)}
                        />
                      </div>
                    </Col>
                    <Row className="m-2">
                      {hospitalList
                        ?.filter((item) => item?.branch?.id === branchItem?.id)
                        .map((hospitalItem, index) => (
                          <React.Fragment key={index}>
                            <Col className="col-12 col-sm-6">
                              <FormCheckbox
                                id={"Hospital" + index}
                                required={false}
                                name={hospitalItem?.name}
                                label={hospitalItem?.name}
                                checked={data?.hospital.includes(hospitalItem.id)}
                                onChange={(e) => {
                                  setItHasChanges(true);
                                  let updatedList = [...data.hospital];
                                  if (e.target.checked) {
                                    updatedList.push(hospitalItem.id);
                                  } else {
                                    updatedList = updatedList.filter((id) => id !== hospitalItem.id);
                                  }
                                  updateData("hospital", updatedList);
                                }}
                              />
                            </Col>
                          </React.Fragment>
                        ))}
                    </Row>
                  </React.Fragment>
                );
              })}

              {otherHomeCare?.map((hospitalItem, index) => {
                const allOtherHospitalsChecked = hospitalList
                  ?.filter((item) => item?.branch?.id === hospitalItem?.branch?.id)
                  .every((hospital) => data?.hospital.includes(hospital.id));
                return (
                  <React.Fragment key={index}>
                    {index === 0 && (
                      <>
                        <Col className="col-12 col-sm-6">
                          <div className="form-group">
                            <FormCheckbox
                              label={"Other"}
                              labelClassName="fw-bold"
                              id={"otherHomeCare"}
                              name="status"
                              checked={allOtherHospitalsChecked}
                              onChange={handleOtherChange}
                            />
                          </div>
                        </Col>
                        <Row className="m-2">
                          {otherHomeCare.map((hospitalItem, index) => (
                            <React.Fragment key={index}>
                              <Col className="col-12 col-sm-6">
                                <FormCheckbox
                                  id={"OtherHospital" + index}
                                  required={false}
                                  name={hospitalItem?.name}
                                  label={hospitalItem?.name}
                                  checked={data?.hospital.includes(hospitalItem.id)}
                                  onChange={(e) => handleOtherHospitalChange(e, hospitalItem.id)}
                                />
                              </Col>
                            </React.Fragment>
                          ))}
                        </Row>
                      </>
                    )}
                  </React.Fragment>
                );
              })}
            </Col>
          </Row>
        )}
      </Form>
      <Block className="text-end mt-3">
        <ul className="align-center justify-content-end flex-wrap flex-sm-nowrap gx-2 gy-2">
          <li>
            <CarerPreviousButton className="w-100px" title="Back" size="md" onClick={() => onPrev()} />
          </li>
          <li>
            <ActionButton
              className="w-100px"
              title="Save"
              size="md"
              onClick={() => {
                onNext();
              }}
            />
          </li>
        </ul>
      </Block>
    </div>
  );
};

export default CarerHomeCare;
